import { useEffect, useRef, useState } from 'react';

import { SettingsIcon } from './icons';

export function SettingsPopover({
  isPersistEnabled,
  onTogglePersist,
}: {
  isPersistEnabled: boolean;
  onTogglePersist: () => void;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  // Close on click outside
  useEffect(() => {
    if (!isOpen) return;
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [isOpen]);

  return (
    <div ref={ref} className="relative">
      <button
        className={`text-secondary hover:text-emphasis hover:bg-fillHover cursor-pointer rounded-md p-1.5 transition-colors ${isOpen ? 'bg-fillHover text-emphasis' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Debugger settings"
      >
        <SettingsIcon size={16} />
      </button>

      {isOpen ? (
        <div className="bg-surface absolute top-full right-0 z-10 mt-1 w-56 rounded-lg border p-3 shadow-lg">
          <h3 className="text-emphasis mb-2 text-xs font-bold tracking-wide uppercase">
            Settings
          </h3>
          <label className="flex cursor-pointer items-center gap-2">
            <input
              type="checkbox"
              checked={isPersistEnabled}
              onChange={onTogglePersist}
            />
            <span className="text-default text-xs">Persist on refresh</span>
          </label>
        </div>
      ) : null}
    </div>
  );
}
